// @flow

import * as React from 'react';
import img1 from 'app/images/globalLeaderboard/howItWorksWorldCup/1.jpg';
import img2 from 'app/images/globalLeaderboard/howItWorksWorldCup/2.jpg';
import img3 from 'app/images/globalLeaderboard/howItWorksWorldCup/3.jpg';
import img4 from 'app/images/globalLeaderboard/howItWorksWorldCup/4.jpg';
import mobileImg1 from 'app/images/globalLeaderboard/howItWorksWorldCup/mobile_01.jpg';
import mobileImg2 from 'app/images/globalLeaderboard/howItWorksWorldCup/mobile_02.jpg';
import mobileImg3 from 'app/images/globalLeaderboard/howItWorksWorldCup/mobile_03.jpg';
import mobileImg4 from 'app/images/globalLeaderboard/howItWorksWorldCup/mobile_04.jpg';
import HowToPlay from 'app/components/leaderboard/HowToPlay';
import ResponsiveBanner from 'app/components/commons/ResponsiveBanner';

function WorldCupHowToPlay() {
  return (
    <div>
      <ResponsiveBanner desktopImage={img1} mobileImage={mobileImg1} />
      <ResponsiveBanner desktopImage={img2} mobileImage={mobileImg2} />
      <ResponsiveBanner desktopImage={img3} mobileImage={mobileImg3} />
      <ResponsiveBanner desktopImage={img4} mobileImage={mobileImg4} />
      <HowToPlay playLink="/lobby/football/wc">
        <p>
          You must enter a minimum of 3 Football World Cup Challenges to feature on the Football
          World Cup Ultimate Champion Leaderboard and be eligible for a prize. Your Global Score
          determines your position on the Leaderboard. The Leaderboard will be finalized 48 hours
          after the Football World Cup final on 18th of July 2018 allowing for any adjustments from
          our data providers. Your account must be verified before you can receive your prize. All
          prizes will be distributed after the 23/8/18 once token generation event has occurred.
          Prizes will be redeemable for your local currency after the 23/8/18 through designated
          partnered exchanges on playchip.global.
        </p>
        <p>
          In the case of a tie, the member who has entered more Football World Cup Challenges wins.
          If there is still a tie, the winner will be the member who joined PlayChip Fantasy first.
          The Second Chance Draw will occur on Wednesday 30th July. All members who enter a Football
          World Cup Challenge will be sent an email which will require a response to be eligible to
          enter.
        </p>
        <p>
          PlayChip Fantasy reserves the right to publish winner&apos;s details on our site, in our
          newsletter and/or our marketing material. By entering any Football World Cup Challenge you
          give us this right. PlayChip Fantasy may share your information with 3rd parties for the
          purposes of running this promotion and delivering your prize.
        </p>
      </HowToPlay>
    </div>
  );
}

export default WorldCupHowToPlay;
